__turbopack_context__.v({
  "column": "Columns-module-scss-module__xNBkWa__column",
  "grid": "Columns-module-scss-module__xNBkWa__grid",
});
